// extracted by mini-css-extract-plugin
module.exports = {"main":"omNuA","link":"ltOqm","ml8":"fPIdq","loading":"P_fSP","affspin":"b3IjS"};